
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/horse-racing/tracks",
      function () {
        return require("private-next-pages/horse-racing/tracks/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/horse-racing/tracks"])
      });
    }
  